import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bookListItemSelected: 0, // Default value
};

const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {
    setBookListItemSelected: (state, action) => { state.bookListItemSelected = action.payload },
    reset4Book: () => initialState,
  },
});

export const { setBookListItemSelected, reset4Book } = bookSlice.actions;
export default bookSlice.reducer;